/**
 * List Schema of ResponseRoboCnpj
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponseRoboCnpj} from '@/model/resource/ResponseRoboCnpj'

/* TODO: review generated schema */
export class ListResponseRoboCnpjSchema extends Schema {
  readonly name = 'ListResponseRoboCnpj'

  readonly fieldSet: FieldSet<ResponseRoboCnpj> = {
    idResponsePk: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpj: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.cnpj(schema.model.cnpj),
      },
    }),
    response: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
